const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        name: 'Root',
        path: '',
        redirect: { name: 'Home' }
      },
      {
        name: 'Home',
        path: '/home',
        component: () => import('pages/HomePage.vue')
      },
      {
        name: 'CreditProcessList',
        path: '/credit-process',
        component: () => import('pages/credit-process/CreditProcessList.vue')
      },
      {
        name: 'SalesList',
        path: '/sales',
        component: () => import('pages/sales/SalesList.vue')
      }
    ]
  }
]

export default routes
